// extracted by mini-css-extract-plugin
module.exports = {"tableContent":"styles_tableContent__2JjOG","tableWrapper":"styles_tableWrapper__18vHh","tableContainer":"styles_tableContainer__3X71X"};